<div id="managePopUp" *ngIf="!strategicPortIn">
  <div class="modal-header">
    <div class="modal-title">{{headerText}}</div>
  </div>

  <div class="modal-body" *ngIf="listOfNonActiveLines && listOfNonActiveLines.length">
    <div>
      <p class="about-suspend">
        {{displayMsg}}
      </p>
      <div class="row" *ngFor='let line of listOfNonActiveLines'>
        <div class="col-12">
          <span class="line-number">
            {{line?.msisdn | formatMsisdn}}
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn secondary_btn order-sm-2" (click)="cancelTransaction()"> {{cancelBtnTxt}} </button>
    <button type="button" class="btn primary_btn " (click)="changeCurrentSelection()"> {{removeBtnTxt}} </button>
  </div>
</div>
